// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"13a2c32ddfa9c5a0fde2","404":"dbc210e055d5c7656b28","406":"8e98797fb5ccfc15016d"}[chunkId] + ".css";
};